import React, { Component } from "react";
import BookmarkListView from "presentational/portfolio/BookmarkListView";
import TXT from "presentational/common/multinational/TXT";
import { withStore } from "store/storeHandler";
import { withToken } from "lib/forceTokenRenewComponent";

class BookmarkList extends Component {
  initBookmarkList = async () => {
    const { BookmarkActions, AppErrorActions, getIdTokenWT } = this.props;
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await BookmarkActions.initOutfitList(idToken);
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  requestBookmarkList = async () => {
    const { BookmarkActions, AppErrorActions, getIdTokenWT } = this.props;
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await BookmarkActions.getOutfitList(idToken);
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  changeBookmarkList = async folderHash => {
    const { BookmarkActions, AppErrorActions, getIdTokenWT } = this.props;
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await BookmarkActions.changeOutfitListOfFolder({ idToken, folderHash });
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  handleFolderChange = (key, newHash) => {
    const { nowBookmarkFolderHash } = this.props;
    if (nowBookmarkFolderHash !== newHash) {
      this.changeBookmarkList(newHash);
    }
  };

  handleFolderCreateBtnSubmit = async folderName => {
    const {
      BookmarkActions,
      NoticeModalActions,
      AppErrorActions,
      getIdTokenWT
    } = this.props;
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;

    if (!folderName || folderName.trim().length === 0) return null;

    try {
      const { needCreative, success, hash } =
        await BookmarkActions.createBookmarkFolder({
          idToken,
          folderName
        });
      if (success) {
        this.changeBookmarkList(hash);
      } else if (needCreative) {
        NoticeModalActions.openModal({
          content: <TXT name="msg_createFolderLimit" />
        });
      } else {
        NoticeModalActions.openModal({
          content: <TXT name="msg_commonNetworkError" />
        });
      }
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  handleFolderEditBtnSubmit = async ({ folderHash, newName }) => {
    const {
      BookmarkActions,
      NoticeModalActions,
      AppErrorActions,
      getIdTokenWT
    } = this.props;
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;

    if (!newName || newName.trim().length === 0) return null;

    try {
      const { success } = await BookmarkActions.editBookmarkFolder({
        folderHash,
        newFolderName: newName,
        idToken
      });
      if (!success) {
        NoticeModalActions.openModal({
          content: <TXT name="msg_commonNetworkError" />
        });
      }
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  handleFolderDeleteBtnSubmit = async ({ folderHash }) => {
    const {
      BookmarkActions,
      NoticeModalActions,
      AppErrorActions,
      getIdTokenWT
    } = this.props;
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await BookmarkActions.changeOutfitListOfFolder({
        idToken,
        folderHash: "all"
      });

      const { success } = await BookmarkActions.deleteBookmarkFolder({
        folderHash,
        idToken
      });

      if (!success) {
        NoticeModalActions.openModal({
          content: <TXT name="msg_commonNetworkError" />
        });
      }
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  render() {
    const {
      isLoading,
      isEnd,
      outfitList,
      bookmarkFolderList,
      nowBookmarkFolderHash
    } = this.props;

    return (
      <BookmarkListView
        list={outfitList}
        isLoading={isLoading}
        isEnd={isEnd}
        bookmarkFolderList={bookmarkFolderList}
        selectedFolderHash={nowBookmarkFolderHash}
        onFolderChange={this.handleFolderChange}
        callNextListFn={this.requestBookmarkList}
        onFolderCreateBtnSubmit={this.handleFolderCreateBtnSubmit}
        onFolderEditBtnSubmit={this.handleFolderEditBtnSubmit}
        onFolderDeleteBtnSubmit={this.handleFolderDeleteBtnSubmit}
      />
    );
  }

  componentDidMount() {
    this.initBookmarkList();
  }
}

export default withToken(
  withStore({
    stateMap: {
      bookmark: [
        "outfitList",
        "isLoading",
        "isEnd",
        "bookmarkFolderList",
        "nowBookmarkFolderHash"
      ]
    },
    dispatchMap: ["bookmark", "appError", "noticeModal"]
  })(BookmarkList)
);
